export const environment = {
    production: false,
    client_id: "scada-client",
    client_secret: "scada-secret",
    host: "https://device.scada.senzmatica.com/service",
    testHost: "http://38.242.225.23:8080/service",
    chatbotHost: "https://chatbot.senzmatica.com/service",
    rootCauseHost: "https://automlbe.senzmatica.com",
    skipOauth: false,
    autoMl: "http://20.102.106.137:3009/project-init",
    enableUserLog: false,
    devicePulse: true,
    azurepackageFreeId: "plan_free_001",
    azurepackageBasicId: "basic_live_test",
    azurepackagePremiumId: "plan_premium_001",
    azurePackageUpgradeLink: "https://portal.azure.com/#browse/Microsoft.SaaS%2Fresources",
    azurepageLink: "https://portal.azure.com/#home",
    contactUsLink: "https://www.senzmate.com/company/contact/",
    azureAd: {
      clientId: "fc3f355f-2ef0-4aa8-babd-b721990a365e",
      tenantId: "common"
    },
    firebase: {
      apiKey: 'AIzaSyA9uKFEIqgW63abTdvYTqb3gS6r-60FRpi',
      authDomain: 'senzagro-c3d33.firebaseapp.com',
      databaseURL: 'https://senzagro-c3d33.firebaseio.com',
      projectId: 'senzagro-c3d33',
      storageBucket: 'senzagro-c3d33.appspot.com',
      messagingSenderId: '283658892245',
      appId: '1:283658892245:web:e206dc51d4a2719e75c35c',
      measurementId: 'G-E5NKHDMS7N'
  },
  useFirebase:false
};
